<template>
  <sFormItem
    v-if="display"
    ref="form_item"
    :class="`offer-criterion offer-criterion-${criterion.id}-${criterion.title}`"
    :label="criterion.title"
    :prop="form_prop">
    <sInput-number
      v-if="type == 'NUMERIC_INPUT'"
      :data-qa="`offer-criterion-${criterion.id}-${criterion.title}-numeric`"
      :disabled="disabled"
      placeholder="0.00"
      :precision="criterion.decimals"
      :readonly="!!criterion.fixedValue"
      :value.sync="model"/>
    <sInput-number
      v-else-if="type == 'CALCULATED'"
      :data-qa="`offer-criterion-${criterion.id}-${criterion.title}-calculated`"
      :disabled="disabled"
      placeholder="0.00"
      readonly
      :value.sync="model"/>
    <sSelect
      v-else-if="type == 'DICTIONARY'"
      class="width-100"
      clearable
      :data-qa="`offer-criterion-${criterion.id}-${criterion.title}-dictionary-select`"
      :disabled="disabled"
      filterable
      :placeholder="$t('Common.ChooseValue')"
      :value.sync="model">
      <sOption
        v-for="opt in criterion.dictionaryValues"
        :key="`dictionary-item-${opt.id}`"
        :data-qa="`dictionary-item-${opt.title}`"
        :disabled="disabled"
        :label="opt.title"
        :value="opt.id">
        {{ opt.title }} ({{ opt.score }}%)
      </sOption>
    </sSelect>
    <sInput
      v-else-if="type == 'BIG_TEXT'"
      clearable
      :data-qa="`offer-criterion-${criterion.id}-${criterion.title}-text`"
      :disabled="disabled"
      :max-length="4000"
      max-rows="20"
      :placeholder="$t('Common.EnterText')"
      :readonly="!!criterion.fixedValue"
      rows="1"
      type="textarea"
      :value.sync="model"/>
  </sFormItem>
</template>

<script>
import isCriterionDisplayed from 'utils/criterionDisplay'

export default {
  name: 'offerCriterion',
  props: {
    criterion: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number],
    },
    all_criteria: Array,
    form_prop: String,
    disabled: Boolean,
  },
  computed: {
    model: {
      get() {
        let value = this.value
        if (!value) {
          if ( this.type == 'DICTIONARY' ) {
            return null
          } else if ( this.type == 'NUMERIC_INPUT' || this.type == 'BIG_TEXT') {
            return ''
          }
        }
        if ( this.type == 'CALCULATED') {
          let formula = this.criterion.calculationFormula
          this.$_.forEachRight(this.all_criteria, crit => {
            if ( crit.criterion.formulaCode ) {
              formula = formula?.replaceAll(crit.criterion.formulaCode, crit.value || 0 )
            }
          })
          return eval(formula)
        }
        return value
      },
      set(value) {
        this.$emit('update:value', value )
      }
    },
    type() {
      return this.criterion.criterionControlType
    },
    calculated() {
      let formula = this.criterion.calculationFormula
      this.$_.forEachRight(this.all_criteria, crit => {
        if ( crit.criterion.formulaCode ) {
          formula = formula?.replaceAll(crit.criterion.formulaCode, crit.value || 0 )
        }
      })
      return eval(formula)
    },
    display() {
      return isCriterionDisplayed(this.criterion, this.all_criteria)
    }
  },
  methods: {
    clearModel() {
      this.model = null
    },
    updValid( value) {
      this.$refs.form_item.$emit.apply(this.$refs.form_item, ['s.form.change'].concat(value))
    },
  },
  watch: {
    display(val,old) {
      if ( !val && old ) {
        this.clearModel()
      }
    },
  }
}
</script>
